import axios from 'axios';
import Cookies from 'js-cookie';
import {
  EventBus
} from '@/main.js'

const standard = axios.create({
    baseURL: process.env.VUE_APP_API_HOST,
    timeout: 100000,
    transformResponse: [
        function(data) {
            return data;
        },
    ],
});

if (Cookies.get('auth_greennCourse')) {
    standard.defaults.headers.common['Authorization'] = Cookies.get('auth_greennCourse');
}

standard.interceptors.response.use(function (response) {
    return response;
  }, function (err) {
    if (err.response) {
      switch (err.response.status) {
        case 401:
          let data = JSON.parse(err.response?.data);
          if(data.message !== 'Session is not available') {
            return;
          }
          
          EventBus.$emit('logout')
          break;
        default:
          return Promise.reject(err);
      }
      return err;
    }
});
  

//standard.defaults.headers.common['Access-Control-Allow-Headers'] = 'Set-Cookie'

// standard.interceptors.response.use(..., ...)

export default standard;